import { render, staticRenderFns } from "./CreateComment.vue?vue&type=template&id=1721d774&scoped=true&"
import script from "./CreateComment.vue?vue&type=script&lang=js&"
export * from "./CreateComment.vue?vue&type=script&lang=js&"
import style0 from "./CreateComment.vue?vue&type=style&index=0&id=1721d774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721d774",
  null
  
)

export default component.exports